import { StatusPill } from "../components/StatusPill";
import { formatRelative } from "../lib/format";
import { fetchDashboardLeaders } from "../lib/dashboard";
import { DashboardStateView, useDashboardQuery } from "../hooks/useDashboardQuery";

export function LeadersPage() {
  const state = useDashboardQuery(fetchDashboardLeaders);

  return (
    <>
      <div className="page-header">
        <div>
          <h1>Leaders</h1>
          <p>Registered signal providers for this tenant. No synthetic market performance.</p>
        </div>
        <StatusPill label="Read-only" tone="neutral" />
      </div>
      <DashboardStateView
        state={state}
        emptyTitle="No leaders registered"
        emptyDetail="Create leaders via the copy API when authorized. This view is read-only."
      >
        {(data) => (
          <div className="card-grid">
            {data.leaders.map((leader) => (
              <article className="entity-card" key={leader.leaderId}>
                <div style={{ display: "flex", justifyContent: "space-between", gap: 8 }}>
                  <h3>{leader.name}</h3>
                  <StatusPill label={leader.brokerProvider} tone="neutral" />
                </div>
                <div className="entity-meta">
                  <div>
                    Leader ID: <strong className="mono">{leader.leaderId}</strong>
                  </div>
                  <div>
                    Account: <strong className="mono">{leader.leaderAccountId}</strong>
                  </div>
                  <div>
                    Linked relationships: <strong>{leader.followerCount}</strong>
                  </div>
                  <div>
                    Updated: <strong>{formatRelative(leader.updatedAt)}</strong>
                  </div>
                </div>
              </article>
            ))}
          </div>
        )}
      </DashboardStateView>
    </>
  );
}
